module.exports = __webpack_public_path__ + "static/media/user2.d149062b.jpg";